module.exports = __webpack_public_path__ + "static/media/download-icon.a6ac2c70.png";